/*global google*/
import { InfoWindow, Marker, MarkerProps, useGoogleMap } from "@react-google-maps/api";
import React, { FunctionComponent, useCallback, useContext, useState } from "react";
import { RouteContext } from "./route-context";

interface ICustomFlatRouteMarkerProps extends MarkerProps {
  id: string;
  onClick?: () => void;
  number?: string;
  doRenderCustomInfoWindow?: boolean;
  renderCustomInfoWindow?: (markerId: string) => JSX.Element | "";
}

export const CustomFlatRouteMarker: FunctionComponent<ICustomFlatRouteMarkerProps> = (props) => {
  const {
    id,
    position,
    doRenderCustomInfoWindow,
    renderCustomInfoWindow = () => {
      return "";
    },
    draggable,
    ...other
  } = props;
  const [markerOpacity, setMarkerOpacity] = useState<number>(0);
  const instance = useGoogleMap();
  const { selectedStopId, setSelectedStopId } = useContext(RouteContext);

  const onMarkerClicked = useCallback(() => {
    if (instance) {
      setMarkerOpacity(0);
      setSelectedStopId(id);
    }
  }, [instance, id, setSelectedStopId]);

  const getIcon = () => {
    return {
      url: "http://maps.google.com/mapfiles/kml/shapes/placemark_circle.png",
      anchor: new google.maps.Point(16, 16),
    };
  };

  const getInfoWindowContent = () => {
    if (doRenderCustomInfoWindow) {
      return renderCustomInfoWindow(id);
    }
    return null;
  };

  const onMouseOver = useCallback(() => {
    setMarkerOpacity(1);
  }, []);

  const onMouseOut = useCallback(() => {
    setMarkerOpacity(0);
  }, []);

  return (
    <Marker
      key={`map_${id}`}
      position={position}
      icon={getIcon()}
      onClick={onMarkerClicked}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      opacity={markerOpacity}
      {...other}
      draggable={selectedStopId === id && draggable}
    >
      {selectedStopId === id && (
        <InfoWindow onCloseClick={() => setSelectedStopId(null)} position={position}>
          {getInfoWindowContent()}
        </InfoWindow>
      )}
    </Marker>
  );
};
